import { Check, X, FileEdit, ShieldCheck } from "lucide-react";

// Semantic status pill matching every status the operator surfaces:
//   Run / Quick-Sim / Matrix-cell / Optimisation-study / Optimisation-candidate.
//
// Phase 3 (ROE UI) added: draft, validated, partial.
// running / cancelling get the pulse dot; cached / cancelled / queued / draft
// stay neutral; succeeded gets the check icon; failed the X icon.
const VARIANTS = {
    // Workflow lifecycle
    draft: { cls: "bg-ux-bg-3 text-ux-text-3", dot: false, icon: FileEdit },
    validated: { cls: "bg-ux-info-soft text-ux-info", dot: false, icon: ShieldCheck },
    queued: { cls: "bg-ux-bg-3 text-ux-text-2", dot: false, icon: null },
    running: { cls: "bg-ux-accent-soft text-ux-accent", dot: true, icon: null },
    cancelling: { cls: "bg-ux-warning-soft text-ux-warning", dot: true, icon: null },
    // Terminal
    succeeded: { cls: "bg-ux-success-soft text-ux-success", dot: false, icon: Check },
    partial: { cls: "bg-ux-warning-soft text-ux-warning", dot: false, icon: null },
    failed: { cls: "bg-ux-danger-soft text-ux-danger", dot: false, icon: X },
    cancelled: { cls: "bg-ux-bg-3 text-ux-text-3", dot: false, icon: null },
    cached: { cls: "bg-ux-info-soft text-ux-info", dot: false, icon: null },
    rejected_by_constraint: { cls: "bg-ux-bg-3 text-ux-text-3", dot: false, icon: null },
    // Generic semantic colours
    ok: { cls: "bg-ux-success-soft text-ux-success", dot: false, icon: null },
    error: { cls: "bg-ux-danger-soft text-ux-danger", dot: false, icon: null },
    default: { cls: "bg-ux-bg-3 text-ux-text-2", dot: false, icon: null },
};

function statusLabel(key) {
    if (!key) return "—";
    if (key === "rejected_by_constraint") return "Rejected";
    return key.charAt(0).toUpperCase() + key.slice(1);
}

export default function StatusPill({ status, children, testId, className = "" }) {
    const key = (status || "default").toLowerCase();
    const v = VARIANTS[key] || VARIANTS.default;
    const Icon = v.icon;
    return (
        <span
            data-testid={testId || `status-pill-${key}`}
            className={[
                "inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-md text-[12px] font-medium tabular-nums",
                v.cls,
                className,
            ].join(" ")}
        >
            {v.dot && <span className="pulse-dot" aria-hidden />}
            {Icon && <Icon className="w-3 h-3" aria-hidden />}
            <span>{children || statusLabel(status)}</span>
        </span>
    );
}
